let locales = {
    cronConfig_announcement: 'Cron campagne',
    cronConfig_interval: 'Intervallo di esecuzione in millisecondi (minimo 60000)',
};
export default locales;